/**
 * La espera entre un correo y el siguiente, y cómo se nombra en el botón.
 *
 * Vive aquí y no dentro de una pantalla porque ya son TRES los sitios que
 * reenvían un correo —recuperar contraseña, reenviar la verificación desde
 * `/verificar`, y reenviarla desde el login cuando la cuenta no está
 * verificada—. Con la constante escrita en cada uno, el día que la espera
 * cambie a 60 s habría que acordarse de los tres, y el que se olvide no
 * fallaría: simplemente esperaría distinto que los otros dos.
 */

/**
 * Lo que se espera entre un envío y el siguiente.
 *
 * No es antifraude —para eso está el límite de intentos del servidor—:
 * es para que el doble clic nervioso de quien no ve llegar el correo en
 * cinco segundos no dispare tres correos idénticos, que es justo lo que
 * hace que el proveedor marque el dominio como spam.
 */
export const RESEND_COOLDOWN_SECONDS = 30;

/** Lo que dice un botón mientras corre la espera. */
export function waitLabel(seconds: number): string {
  return `Espera ${seconds} s`;
}
